module.exports = __webpack_public_path__ + "static/media/crying.3c11021e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/crying.svg
// module id = 484
// module chunks = 0